module.exports = __webpack_public_path__ + "img/01.7a4014e7.png";